import { render, staticRenderFns } from "./AlmacenVisitsTable.vue?vue&type=template&id=4dd13508"
import script from "./AlmacenVisitsTable.vue?vue&type=script&lang=js"
export * from "./AlmacenVisitsTable.vue?vue&type=script&lang=js"
import style0 from "./AlmacenVisitsTable.vue?vue&type=style&index=0&id=4dd13508&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports